'use strict';

var $ = window.jQuery;
var xhrSet = {};

module.exports = function selfCancelingAjax(requestName, ajaxOptions, done, fail) {
	if (xhrSet[requestName] && xhrSet[requestName].readyState !== 4) {
		xhrSet[requestName].abort();
	}
	xhrSet[requestName] = makeRequest(ajaxOptions, done, wrapFail(fail));
};

function makeRequest(options, done, fail) {
	return window.jQuery.ajax(options).done(done).fail(fail);
}

function wrapFail(callback) {
	return function failWrapper(jqxhr, status, error) {
		if (jqxhr.readyState === 4) {
			callback(jqxhr, status, error);
		}
	};
}
